import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { InsuranceDto } from './insurance-dto';



export class InsuranceResponse extends GlobalResponseObject{
    data?: InsuranceDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: InsuranceDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

